export const mailingList = {
  // Admin mailing list endpoint
  MAILING_LIST: 'v2/mailer/mailing-list',
};
